export default {
    path: '/bonus_detail',
    meta: {
        title: '分红明细',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/bonus_detail`),
}


// WEBPACK FOOTER //
// ./src/views/BonusDetail/router.js